import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  ApiVisa,
  BudgetItemService,
  BudgetLineService,
  Pagination,
  bl_fi_budget_item_RowClass,
} from "blg-akaun-ts-lib";
import { AppConfig } from "../../visa";
import { forkJoin, from } from "rxjs";
import { concatMap } from "rxjs/operators";
import { SubSink } from "subsink2";

@Component({
  selector: "app-select-budget-item-gen-doc",
  templateUrl: "./select-budget-item-gen-doc.component.html",
  styleUrls: ["./select-budget-item-gen-doc.component.css"],
})
export class SelectBudgetItemGenDocComponent implements OnDestroy, OnChanges {
  @Input() budgetItem = new FormControl();
  @Input() budgetVotebookGuid: string;
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  apiVisa: ApiVisa = AppConfig.apiVisa;

  allBudgetItems: any;
  searchBudgetItems: any = [];

  constructor(
    private budgetItemService: BudgetItemService,
    private budgetLineService: BudgetLineService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ("budgetVotebookGuid" in changes) {
      // React to changes in budgetVotebookGuid here
      const newGuid = this.budgetVotebookGuid;
      // Perform operations based on the new value
      if (newGuid !== null) {
        this.subs.sink = this.budgetLineService
          .getByCriteria(
            new Pagination(0, 10000, [
              {
                columnName: "votebook_guid",
                operator: "=",
                value: newGuid,
              },
            ]),
            this.apiVisa
          )
          .pipe(
            concatMap((records) =>
              forkJoin(
                records.data.map((record) =>
                  from(
                    this.budgetItemService.getByGuid(
                      record.bl_fi_budget_line.budget_item_guid.toString(),
                      AppConfig.apiVisa
                    )
                  )
                )
              )
            )
          )
          .subscribe((results) => {
            let filteredBudgetItems: bl_fi_budget_item_RowClass[] = [];
            results.forEach((item) => {
              filteredBudgetItems.push(item.data.bl_fi_budget_item);
            });
            const budgetItemListing = filteredBudgetItems.map(
              (data, index) => ({
                name: data.name,
                code: data.code,
                guid: data.guid,
              })
            );
            this.allBudgetItems = budgetItemListing;
            this.searchBudgetItems = budgetItemListing;
          });
      }
    }
  }

  applyBudgetItemFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.searchBudgetItems = this.allBudgetItems.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
